import React from "react";
import { notify } from "@/shared/utils/notify";
import { saucesService } from "../../../shared/services";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

export const useCreateSauce = ({setOpenModalCreate}: {setOpenModalCreate: (val: boolean) => void}) => {
  const [loading, setLoagding] = React.useState<boolean>(false);

  const {
    control,
    handleSubmit: onSubmit,
    reset,
    watch,
    setValue
  } = useForm<any>({
    resolver: yupResolver(
      yup.object({
        // name: yup.string().required('Campo requerido'),
        // address: yup.string().required('Campo requerido'),
        // latitude: yup.string().required('Campo requerido'),
        // longitude: yup.string().required('Campo requerido')
      }),
    )
  });

  const handleSubmit = onSubmit(async (data:any) => {
    
    if (loading) return
    
    setLoagding(true)
    await saucesService
      .create({...data })
      .then((_res: any) => {
        notify.success(`Se ha creado la salsa ${data.name} exitosamente`);
        setOpenModalCreate(false)
        reset({});
      })
      .catch((err: any) => {
        notify.error(err.message);
        return err.message;
      }).finally(()=>{
        setLoagding(false)
      })
  }  )

  return {
    loading,
    control,
    handleSubmit,
    watch,
    setValue,
  };
};
